export { default } from "./useImplementationGuideCompletionRateGet";
